module.exports = __webpack_public_path__ + "static/pic11.d9e39c8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic11.jpg
// module id = 529
// module chunks = 87192162464282